var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-autocomplete", {
        attrs: {
          "hide-details": "",
          dense: "",
          outlined: "",
          name: _vm.field.fieldName,
          items: _vm.field.list,
          "item-text": "text",
          "item-value": "value",
        },
        on: {
          change: function ($event) {
            _vm.field.value = _vm.value
          },
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }